module.exports = __webpack_public_path__ + "static/media/3d.7a42588c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/3d.png
// module id = 92
// module chunks = 0